import { WalletConnectConnector } from '@web3-react/walletconnect-connector'
import { NETWORK_MAP } from 'config/constants/network'
import { Token } from 'config/types'
import { Trans } from 'react-i18next'
import { useWalletInfo } from 'state/auth/hooks'
import styled from 'styled-components'
import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import CircleLoader from 'UIKit/Loader/CircleLoader'
import Text from 'UIKit/Text'
import { StyledActionButton } from '../../../components/styles'

interface SwitchNetworkToDepositButtonProps {
  onSwitchNetwork: () => void
  isSwitchingNetwork: boolean
  selectedToken: Token
}

const SwitchNetworkToDepositButton: React.FC<SwitchNetworkToDepositButtonProps> = ({
  onSwitchNetwork,
  isSwitchingNetwork,
  selectedToken,
}) => {
  const { walletInfo, onConnectByWalletType } = useWalletInfo()

  return (
    <>
      <StyledActionButton disabled={isSwitchingNetwork} onClick={onSwitchNetwork} width="100%">
        {isSwitchingNetwork && (
          <Box mr="12px">
            <CircleLoader />
          </Box>
        )}

        <Text bold fontSize="14px" color={'text'}>
          <Trans>Switch To {{ chainName: NETWORK_MAP[selectedToken.network].networkInfo.displayName }}</Trans>
        </Text>
      </StyledActionButton>

      {walletInfo.adapter instanceof WalletConnectConnector && isSwitchingNetwork && (
        <Flex mt="12px" alignItems="center" justifyContent="center">
          <Text fontSize="14px" color="textSubtle">
            <Trans>If you can't switch network. Try</Trans>
          </Text>

          <StyledReconnect fontSize="14px" ml="4px" onClick={onConnectByWalletType}>
            <Trans>Reconnect</Trans>
          </StyledReconnect>
        </Flex>
      )}
    </>
  )
}

const StyledReconnect = styled(Text)`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
`

export default SwitchNetworkToDepositButton
